// TODO: import from "mask-input" when case sensitivity issue is resolved
// https://github.com/xnimorz/vanilla-masked-input/pull/1
import MaskInput from "mask-input/lib/MaskInput.js";
import loadJS from "fg-loadjs";
import bus from "../bus";
import { FLASH } from "../action-types";
import { fetchCSRFToken } from "../csrf";

const PIN_JS = "https://cdn.pinpayments.com/pin.v2.js";

export default function creditCardForm(el, props) {
  loadJS(PIN_JS, function() {
    const pinApi = new window.Pin.Api(props.publishableKey, props.env);

    const form = el;
    const errorMessage = form.querySelector("#card-error-message");
    const submitButton = form.querySelector("button[type=submit]");
    const useStoredCardInput = form.querySelector("[data-stored-card-input]");

    form.addEventListener("submit", onSubmit);
    submitButton.disabled = false;

    function onSubmit(e) {
      e.preventDefault();

      // Clear error messages
      errorMessage.innerHTML = "";

      if (useStoredCardInput && useStoredCardInput.checked) {
        handleUseStoredCard();
        return;
      }

      const fieldsWithErrors = form.querySelectorAll(
        ".form-card__field--errors"
      );
      [].forEach.call(fieldsWithErrors, function(fieldWithError) {
        fieldWithError.className = fieldWithError.className.replace(
          /\bform-card__field--errors\b/,
          ""
        );
      });
      const inlineErrorMessages = form.querySelectorAll(".form-card__error");
      [].forEach.call(inlineErrorMessages, function(inlineErrorMessage) {
        inlineErrorMessage.parentNode.removeChild(inlineErrorMessage);
      });

      // Disable submit button
      submitButton.disabled = true;
      let addressLine1 = null,
        addressCity = null,
        addressCountry = null;

      let node = form.querySelector("[data-pin-input=address_line1]");
      if (node) {
        addressLine1 = node.value;
      }

      node = form.querySelector("[data-pin-input=address_city]");
      if (node) {
        addressCity = node.value;
      }

      node = form.querySelector("[data-pin-input=address_country]");
      if (node) {
        addressCountry = node.value;
      }

      // Tokenize card with Pin
      const expiryInput = form.querySelector("[data-pin-input=expiry]");
      const card = {
        number: form.querySelector("[data-pin-input=number]").value,
        name: form.querySelector("[data-pin-input=name]").value,
        expiry_month: expiryInput.value.split("/")[0],
        expiry_year: expiryInput.value.split("/")[1],
        cvc: form.querySelector("[data-pin-input=cvc]").value,
        address_line1: addressLine1,
        address_city: addressCity,
        address_country: addressCountry
      };

      pinApi
        .createCardToken(card)
        .then(handleSuccess, handleError)
        .done();
    }

    function handleUseStoredCard() {
      // Submit form to the server
      fetchCSRFToken().then(csrfToken => {
        form.removeEventListener("submit", onSubmit);
        form.submit();
      });
    }

    function handleSuccess(card) {
      // Add card token to the form
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = props.cardTokenInputName;
      input.value = card.token;
      form.appendChild(input);

      // Submit form to the server
      fetchCSRFToken().then(csrfToken => {
        form.removeEventListener("submit", onSubmit);
        form.submit();
      });
    }

    function handleError(response) {
      // Show general error alert in flash message
      bus.emit(FLASH, {
        type: "alert",
        target: ".credit-card-form-scroll-target",
        message: "Sorry, we had a problem processing your credit card."
      });

      // Show error description above fields
      const errorDescription = document.createElement("p");
      errorDescription.innerHTML = response.error_description;
      errorMessage.appendChild(errorDescription);

      // Show fields with error styles and inline messages
      response.messages.forEach(function(paramError) {
        const fieldContainer = form.querySelector(
          `[data-pin-field~=${paramError.param}]`
        );
        const fieldInput = form.querySelector(
          `[data-pin-input~=${paramError.param}]`
        );

        if (fieldContainer) {
          fieldContainer.className += " form-card__field--errors";
        }

        if (fieldInput) {
          const fieldErrorDiv = document.createElement("div");
          fieldErrorDiv.className = "form-card__error";
          fieldErrorDiv.innerHTML = paramError.message;

          fieldInput.parentNode.insertBefore(
            fieldErrorDiv,
            fieldInput.nextSibling
          );
        }
      });

      // Enable the submit button again
      submitButton.disabled = false;
    }
  });

  // Mask the expiry field to match the format "MM / YY"
  function maskExpiryField() {
    const expiryEl = el.querySelector("[data-pin-input=expiry]");

    if (expiryEl.dataset.inputMaskEnabled === "true") {
      new MaskInput(expiryEl, {
        mask: "00/00"
      });
    }
  }
  maskExpiryField();
}
